"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cagliari": {
    "cbbf1d16": [{
      "hkey": "cb119601",
      "slug": "fonsarda-torricelli",
      "name": "Fonsarda-Torricelli",
      "primary": true,
      "skipSearch": false
    }],
    "fonsarda": [{
      "hkey": "cb119601",
      "slug": "fonsarda-torricelli",
      "name": "Fonsarda-Torricelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8f587e26": [{
      "hkey": "7b22ad99",
      "slug": "cagliari",
      "name": "Cagliari",
      "primary": true,
      "skipSearch": false
    }],
    "giorgino": [{
      "hkey": "7b22ad99",
      "slug": "cagliari",
      "name": "Cagliari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "836696af": [{
      "hkey": "10649802",
      "slug": "monte-claro-is-mirrionis",
      "name": "Monte Claro-Is Mirrionis",
      "primary": true,
      "skipSearch": false
    }],
    "is-mirrionis": [{
      "hkey": "10649802",
      "slug": "monte-claro-is-mirrionis",
      "name": "Monte Claro-Is Mirrionis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3afc5d83": [{
      "hkey": "f95e02aa",
      "slug": "monte-mixi-monte-urpinu",
      "name": "Monte Mixi-Monte Urpinu",
      "primary": true,
      "skipSearch": false
    }],
    "monte-urpinu": [{
      "hkey": "f95e02aa",
      "slug": "monte-mixi-monte-urpinu",
      "name": "Monte Mixi-Monte Urpinu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9da89e63": [{
      "hkey": "4a56c09d",
      "slug": "barracca-manna-is-campus",
      "name": "Barracca Manna-Is Campus",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "7553a17c",
      "slug": "monreale-santa-teresa",
      "name": "Monreale-Santa Teresa",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "669a9efc",
      "slug": "monteleone-santa-rosalia",
      "name": "Monteleone-Santa Rosalia",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "f6af4bfe",
      "slug": "santa-maria-chiara-villa-doloretta",
      "name": "Santa Maria Chiara-Villa Doloretta",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "1042ec82",
      "slug": "terramaini-viale-marconi",
      "name": "Terramaini-Viale Marconi",
      "primary": false,
      "skipSearch": false
    }],
    "pirri": [{
      "hkey": "4a56c09d",
      "slug": "barracca-manna-is-campus",
      "name": "Barracca Manna-Is Campus",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cagliari"
    }],
    "2602c33c": [{
      "hkey": "e0baa028",
      "slug": "quartiere-del-sole-la-palma",
      "name": "Quartiere del Sole-La Palma",
      "primary": true,
      "skipSearch": false
    }],
    "quartiere-del-sole": [{
      "hkey": "e0baa028",
      "slug": "quartiere-del-sole-la-palma",
      "name": "Quartiere del Sole-La Palma",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e0e4ce27": [{
      "hkey": "7a615b04",
      "slug": "sant-avendrace-santa-gilla",
      "name": "Sant'Avendrace-Santa Gilla",
      "primary": true,
      "skipSearch": false
    }],
    "sant-avendrace": [{
      "hkey": "7a615b04",
      "slug": "sant-avendrace-santa-gilla",
      "name": "Sant'Avendrace-Santa Gilla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c870b662": [{
      "hkey": "aa37e682",
      "slug": "stampace-ospedale",
      "name": "Stampace-Ospedale",
      "primary": true,
      "skipSearch": false
    }],
    "stampace": [{
      "hkey": "aa37e682",
      "slug": "stampace-ospedale",
      "name": "Stampace-Ospedale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;